import React from 'react';
import cx from 'classnames';

import { wordpressImgToImgixURL } from 'Utilities';

import { RelatedGuides } from 'Storybook/components/local/RelatedGuides';

import styles from './RelatedGuidesClassic.scss';

type Thumbnail = { alt?: string; url: string };
type RelatedGuidesClassicProps = {
  description?: string | null;
  largeTheme?: boolean;
  thumbnail?: string | Thumbnail | null;
  title?: string | null;
  url: string;
};

const RelatedGuidesClassic = ({
  description,
  largeTheme = false,
  thumbnail,
  title,
  url,
}: RelatedGuidesClassicProps) => {
  const isString = typeof thumbnail === 'string';
  const imgixWidth = largeTheme ? 448 : 288;
  const thumbnailUrl = isString ? thumbnail : thumbnail?.url;

  const props = {
    description: description || undefined,
    imgAlt: isString ? '' : thumbnail?.alt,
    imgSrc: thumbnail ? `${wordpressImgToImgixURL(thumbnailUrl)}&w=${imgixWidth}` : undefined,
    onClick: () => {},
    title: title || undefined,
    url,
    wrapperClassName: cx({ [styles.largeTheme]: largeTheme }),
  };

  return <RelatedGuides {...props} />;
};

export default RelatedGuidesClassic;
